import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import UsersRating from "./UsersRating";
import { getUserListsHod, saveTheUserRating, fetchRatingEmailDropdown } from "services/redux/brandActivtion/meetings/action";

const mapStateToProps = (state) => ({
    usersListingUnderHod: state.baMeetingReducer.usersListingUnderHod,
    saveUsersRating: state.baMeetingReducer.saveUsersRating,
    emailDropdownFilter: state.baMeetingReducer.emailDropdownFilter,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getUserListsHod,
      saveTheUserRating,
      fetchRatingEmailDropdown
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(UsersRating);
